export const defaultStyles = {
  backgroundColor: "var(--theme-email-color-background-secondary)",
  padding: {
    paddingTop: "52",
    paddingBottom: "52",
    paddingLeft: "0",
    paddingRight: "0",
  },
  margin: {
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "0",
    marginRight: "0",
  },
} as const;
